import { useQuery } from '@tanstack/react-query';

import { useUserDetails } from '@/features/_shared/user';

import { fetchFeedArticles } from '../api/fetchFeedArticles';
import { feedArticleKeys } from './feedArticle.keys';

export const useFeedArticles = (feedKeyCategories: string[]) => {
  const { isUserExpired } = useUserDetails();
  return useQuery({
    queryKey: feedArticleKeys.list({ feedKeyCategories }),
    queryFn: () => fetchFeedArticles(feedKeyCategories),
    enabled: !isUserExpired,
    refetchOnWindowFocus: false
  });
};
